import React from 'react';
import { cn } from 'src/domains/common/components/utils';
import { IconButton } from 'src/domains/common/components/button/icon-button';
import { CalendarState } from './CalendarState';
import { observer } from 'src/utils/mobx-react';

type CalendarViewPropsType = {
    calendar: CalendarState;
    showTimePicker: boolean;
};
export const CalendarView = observer(
    'CalendarView',
    ({ calendar, showTimePicker }: CalendarViewPropsType): JSX.Element => {
        const {
            selectDate,
            selectTime,
            selectedDate,
            selectedTimeString,
            daysInMonth,
            nextMonth,
            prevMonth,
            displayedMonth,
            weekDaysLabels,
        } = calendar;
        return (
            <div className='absolute top-full left-0 z-10 py-2'>
                <div
                    className={cn(
                        showTimePicker && 'bg-white p-2 border border-solid border-input rounded-md flex flex-col gap-2'
                    )}
                >
                    {showTimePicker && (
                        <div className='border border-solid border-input rounded-md px-3 py-1'>
                            <input
                                type='time'
                                onChange={(e) => selectTime(e.target.value)}
                                value={selectedTimeString}
                                disabled={selectedDate === null}
                                className='font-sans text-sm text-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:text-muted-foreground border-none'
                            />
                        </div>
                    )}
                    <div className='bg-white p-3 border border-solid border-input rounded-md'>
                        <div className='flex justify-between items-center mb-4'>
                            <IconButton
                                icon='caret-left'
                                variant='outline'
                                onClick={prevMonth}
                            />
                            <p className='text-md m-0 p-0'>{displayedMonth.format('MMMM YYYY')}</p>
                            <IconButton
                                icon='caret-right'
                                variant='outline'
                                onClick={nextMonth}
                            />
                        </div>
                        <div className='grid grid-cols-7 gap-y-2'>
                            {weekDaysLabels.map((day) => (
                                <div
                                    key={day}
                                    className='flex justify-center items-center text-muted-foreground text-[12px]'
                                >
                                    {day}
                                </div>
                            ))}
                            {daysInMonth.map((day) => (
                                <div
                                    key={day.date.toISOString()}
                                    className={cn(
                                        'size-8 flex justify-center items-center text-sm hover:bg-muted rounded-md cursor-pointer',
                                        day.highlighted && '!bg-blue-500 !text-white',
                                        day.disabled && 'cursor-not-allowed text-muted-foreground/50'
                                    )}
                                    onClick={() => day.disabled === false && selectDate(day.date)}
                                >
                                    {day.date.getDayOfMonth()}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
);
